import ApiConstants from "../constants/ApiConstants";
import { TENANT, TenantService } from "../managers/TenantManagerService";
import http from "../http";
import { AxiosRequestConfig } from "axios";
import { getTenantCountryCode } from "../managers/common/CommonUtil";

class IRASService {

    static irasCallBackURL;
    static authenticationData;

    static getCategory() {
        let tenantData = TenantService.getData();
        const countryCode = tenantData[TENANT.COUNTRY_CODE];
        const url = ApiConstants.URL.REPORT.IRAS.MAP_COMPONENTS.GET_MASTER_DATA(countryCode);
        return http.get(url);

    }

    static getCategoryMapping() {
        let tenantData = TenantService.getData();
        const countryCode = tenantData[TENANT.COUNTRY_CODE];
        const url = ApiConstants.URL.REPORT.IRAS.MAP_COMPONENTS.GET_CATEGORY_MAPPING(countryCode);
        return http.get(url);
    }

    static updateMappedComponent(body) {
        const url = ApiConstants.URL.REPORT.IRAS.MAP_COMPONENTS.PUT_MAPPED_COMPONENTS;
        return http.put(url, body);
    }

    static saveMappedComponent(body) {
        const url = ApiConstants.URL.REPORT.IRAS.MAP_COMPONENTS.POST_MAPPED_COMPONENTS;
        return http.post(url, body);
    }

    static getAISSubmissionSummary(parameters) {
        const url = ApiConstants.URL.REPORT.IRAS.GET_SUBMISION_DETAILS
        const config: AxiosRequestConfig = {
            params: parameters,
          };
        return http.get(url, config);
    }

    static getAISSubmittedDetailsData(parameters) {
        const url = ApiConstants.URL.REPORT.IRAS.GET_SUBMITTED_DETAILS
        const config: AxiosRequestConfig = {
            params: parameters,
          };
        return http.get(url, config);
    }

    static getAISSubmissionLogs(parameters) {
        const url = ApiConstants.URL.REPORT.IRAS.GET_SUBMISSION_LOG
        const config: AxiosRequestConfig = {
            params: parameters,
          };
        return http.get(url, config);
    }

    static validateSubmitedUsers(parameters,body) {
        const url = ApiConstants.URL.REPORT.IRAS.POST_VALIDATION;
        const config: AxiosRequestConfig = {
            params: parameters,
        };
        return http.post(url, body, config);
    }

    static postAuthorizationCode(body, isFromNewSetup) {
        const url = ApiConstants.URL.REPORT.IRAS.POST_AUTHORIZATION(body, isFromNewSetup);
        return http.post(url)
    }

    static getReportData(options, userId) {
        const countryCode = getTenantCountryCode();
        const url = ApiConstants.URL.REPORT.IRAS.GET_REPORT(countryCode, userId);
        const config: AxiosRequestConfig = {
            params: options,
        };
        return http.get(url, config);
    }

    static updateIR8AFormDetails(body, recordId) {
        const url = ApiConstants.URL.REPORT.IRAS.UPDATE_FORM(recordId);
        return http.put(url, body)

    }

    static getEmployeeList() {
        const url = ApiConstants.URL.BASE+ApiConstants.URL.PAYROLL.GET_USERS
        return http.get(`${url}?orderBy.field=updatedAt&orderBy.order=desc`)
    }

    static getAppendix8BFormData(param, userId) {
        const URL = ApiConstants.URL.REPORT.APPENDIX_8B.GET(userId);
        return http.get(URL,{params:param})
      }
      static saveAppendix8BDetails(param) {
        const URL = ApiConstants.URL.REPORT.APPENDIX_8B.SAVE;
        return http.put(URL,param)
      }

}
export default IRASService
